import { ManagerRole } from '../../../../../../hooks/auth/usePermissions';

export default {
  form: {
    title: 'Dodaj menedżera',
    first_name: {
      label: 'Imię',
      placeholder: 'Walter',
    },
    last_name: {
      label: 'Nazwisko',
      placeholder: 'White',
    },
    city: {
      label: 'Miasto',
      placeholder: 'Bonn',
    },
    email: {
      label: 'E-mail',
      placeholder: 'thedanger@foodamigos.io',
    },
    roles: {
      label: 'Rola',
      placeholder: 'Wybierz rolę',
      // Add-form label for store_admin sent with as_owner; other store admins keep "Admin".
      owner_option: 'Właściciel',
      options: {
        [ManagerRole.Admin]: 'Administrator',
        [ManagerRole.Reseller]: 'Reseller',
        [ManagerRole.SalesManager]: 'Menedżer sprzedaży',
        [ManagerRole.SalesLeadership]: 'Lider sprzedaży',
        [ManagerRole.ContentManager]: 'Menedżer treści',
        [ManagerRole.OnboardingManager]: 'Menedżer wdrożeń',
        [ManagerRole.MobileAppsManager]: 'Menedżer aplikacji mobilnych',
        [ManagerRole.StoreAdmin]: 'Administrator',
        [ManagerRole.StoreEmployee]: 'Pracownik',
        [ManagerRole.StoreOperator]: 'Operator',
        [ManagerRole.SDR]: 'SDR',
      },
      description: {
        [ManagerRole.StoreOperator]:
          '<strong>Operator:</strong> Pełny dostęp do Sprzedaży, Menu, Top Produktów, Godzin otwarcia, Kart podarunkowych, Rezerwacji i Raportów dla przypisanych firm.',
        [ManagerRole.StoreEmployee]:
          '<strong>Pracownik:</strong> Ograniczony dostęp wyłącznie do Rezerwacji i Kart podarunkowych.',
        [ManagerRole.StoreAdmin]:
          '<strong>Właściciel:</strong> Pełny dostęp do jednej restauracji, w tym witryny sklepu, ustawień podatkowych, marketingu i zarządzania zespołem. Otrzymuje e-mail z danymi logowania. Jeden właściciel na restaurację, inni członkowie zespołu nie mogą go edytować ani usunąć.',
      },
    },
    companies: {
      label: 'Firmy',
      placeholder: 'Wybierz firmy',
      owner_placeholder: 'Wybierz restaurację',
      has_owner: 'Ma właściciela',
    },
  },
  fields: {
    email: 'E-mail',
    name: 'Nazwa',
    roles: 'Rola',
    created_at: 'Utworzono',
    actions: 'Akcje',
    companies: 'Firmy',
    status: 'Status',
  },
  tags: {
    owner: 'Właściciel',
    operator: 'Operator',
    employee: 'Pracownik',
  },
  no_owner: {
    title: '{{restaurant}} nie ma właściciela',
    description: 'Wszystko, co wymaga właściciela, czeka, aż zostanie wybrany.',
  },
  search: {
    placeholder: 'Szukaj po nazwie lub e-mailu',
  },
  buttons: {
    add_manager: 'Dodaj menedżera',
    actions: 'Akcje',
    view_dashboard: 'Wyświetl panel jako ten menedżer',
    login_as_manager: 'Zaloguj się jako ten menedżer',
    delete: 'Usuń tego menedżera',
    resend_owner_invite: 'Wyślij ponownie zaproszenie dla właściciela',
    change_owner: 'Usuń {{name}} z roli właściciela',
    delete_named: 'Usuń {{name}}',
    choose_owner: 'Wybierz właściciela',
  },
  modals: {
    delete_manager: {
      title: 'Czy na pewno chcesz usunąć menedżera {{email}}?',
    },
    update_manager: {
      title: 'Czy na pewno chcesz zaktualizować menedżera {{email}}?',
    },
    resend_owner_invite: {
      title: 'Wysłać ponownie zaproszenie na adres {{email}}?',
      description: 'Właściciel otrzyma e-mailem nowe hasło. Jego obecne hasło przestanie działać.',
    },
  },
  toasts: {
    successfully_created_manager: 'Menedżer został pomyślnie utworzony',
    owner_invited: '{{email}} został zaproszony jako właściciel restauracji i otrzyma dane logowania e-mailem.',
    failed_to_load_data: 'Nie udało się załadować danych, odśwież stronę',
    failed_to_create_manager: 'Nie udało się utworzyć menedżera',
    failed_to_create_magic_link: 'Nie udało się utworzyć magic linku',
    failed_to_delete_manager: 'Nie udało się usunąć menedżera',
    manager_got_deleted: 'Menedżer został usunięty',
    successfully_updated_manager: 'Menedżer został zaktualizowany',
    failed_to_update_manager: 'Nie udało się zaktualizować menedżera',
    owner_invite_resent: 'Zaproszenie zostało ponownie wysłane na adres {{email}} z nowym hasłem.',
    owner_invite_resend_cooling_down:
      'Zaproszenie zostało właśnie wysłane ponownie. Poczekaj kilka minut przed ponownym wysłaniem.',
    failed_to_resend_owner_invite: 'Nie udało się ponownie wysłać zaproszenia',
    owner_changed: '{{name}} jest teraz właścicielem',
    owner_changed_new: '{{name}} jest teraz właścicielem. Dane logowania wysłano na {{email}}',
    owner_removed: '{{name}} nie jest już właścicielem',
  },
};
